export default __webpack_public_path__ + "static/media/ssb_background.c92b4d46.png";